import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { FileUploadConstants } from "../../constants/file-upload.constants";
import { GtConfig, GtInformation, GtTexts } from '@angular-generic-table/core';
import { TranslateService } from "@ngx-translate/core";
import { CustomerService } from "../../services/customer.service";
import { ReportService } from "../../services/report.service";
import { CommonService } from "../../../shared/services/common.service";
import { NotificationType } from "../../enums/notification-types.enum";
import { DatePipe } from "@angular/common";
import { DistributorIdFormatPipe } from "../../../common/pipes/distributor-id-format.pipe";
import { StoreConfig } from "../../../shared/interface/StoreConfig.interface";
import { CurrencyTransformPipe } from "../../../common/pipes/currency-format.pipe";
import { forkJoin } from "rxjs/observable/forkJoin";
import { PayvisionService } from "../../services/payvision.service";
import { PaginationInstance } from "ngx-pagination";
import * as moment from 'moment';
import { Subscription } from 'rxjs';
import { ResponseStatus } from "../../constants/response-status-constants";
import { CacheService } from "../../../shared/services/cache.service";
import { CacheKey } from "../../../shared/constants/cachekey.constants";

@Component({
  selector: "app-order-dashboard",
  templateUrl:
    "../../templates/template1/views/reports/order-dashboard.component.html",
  styleUrls: [
    "../../templates/template1/themes/default/less/order-reports.less",
  ],
  providers: [DistributorIdFormatPipe, CurrencyTransformPipe],
})
export class OrderdashboardComponent {
  @Input() fromDate: string;
  @Input() toDate: string;
  @Input() storeId: [number];
  @Output() isLoadedData = new EventEmitter<boolean>();
  @Output() addFavoriteEvent = new EventEmitter<boolean>();
  @Input() storeInfo: StoreConfig;
  excelIconUrl = environment.cdnURL + "/flpi/images/ms_excel.ico";
  printIconUrl = environment.cdnURL + "/flpi/images/print_icon.png";
  ordersReport = null;
  ordersCount = null;
  request: Subscription;
  dashboardReports = null;
  pageSizes = [25,50,75, 100,125, 150,175, 200];
  pageNumber: number = 1;
  pageSize: number = 25;
  pageCount: number = 0;
  currentDate = new Date();
  allOrdersReport = null;
  isResponseError = false;
  configObject: GtConfig<any>;
  isLoading = false;
  pollCount: number = 0;
  maxPollCount = 15;
  isAllOrdersReportLoading = false;
  isShowReport = true;
  orderLogResponse=[];
  OrderLog=[];
  isPaymentLog=false;
  show:boolean;
  csvType = FileUploadConstants.CSV_FILE_EXTENSION;
  printType = FileUploadConstants.PRINT;
  public paginationInstance: PaginationInstance = {
    id: 'order-reports-pagination',
    itemsPerPage: 10,
    currentPage: 1
};
  displayDashboard = [
    {
      messageType: "OrderSentToAS400",
      processing: 0,
      shipped: 0,
      completed: 0,
      accepted: 0,
      cancelled: 0,
      failed: 0,
      inComplete: 0,
      pending: 0,
      review_window: 0,
      count: 0,
    },
    {
      messageType: "AS400Failure",
      processing: 0,
      shipped: 0,
      completed: 0,
      accepted: 0,
      cancelled: 0,
      failed: 0,
      inComplete: 0,
      pending: 0,
      review_window: 0,
      count: 0,
    },
    {
      messageType: "OrderACKFromAS400",
      processing: 0,
      shipped: 0,
      completed: 0,
      accepted: 0,
      cancelled: 0,
      failed: 0,
      inComplete: 0,
      pending: 0,
      review_window: 0,
      count: 0,
    },
    {
      messageType: "OrderSentToFD",
      processing: 0,
      shipped: 0,
      completed: 0,
      accepted: 0,
      cancelled: 0,
      failed: 0,
      inComplete: 0,
      pending: 0,
      review_window: 0,
      count: 0,
    },
    {
      messageType: "FDFailure",
      processing: 0,
      shipped: 0,
      completed: 0,
      accepted: 0,
      cancelled: 0,
      failed: 0,
      inComplete: 0,
      pending: 0,
      review_window: 0,
      count: 0,
    },
    {
      messageType: "OrderACKFromFDTS",
      processing: 0,
      shipped: 0,
      completed: 0,
      accepted: 0,
      cancelled: 0,
      failed: 0,
      inComplete: 0,
      pending: 0,
      review_window: 0,
      count: 0,
    },
    {
      messageType: "SysOrdNumSentToAS400",
      processing: 0,
      shipped: 0,
      completed: 0,
      accepted: 0,
      cancelled: 0,
      failed: 0,
      inComplete: 0,
      pending: 0,
      review_window: 0,
      count: 0,
    },
    {
      messageType: "SysOrdNumReceivedFromAS400",
      processing: 0,
      shipped: 0,
      completed: 0,
      accepted: 0,
      cancelled: 0,
      failed: 0,
      inComplete: 0,
      pending: 0,
      review_window: 0,
      count: 0,
    },
    {
      messageType: "FulfillmentNumberFromFD",
      processing: 0,
      shipped: 0,
      completed: 0,
      accepted: 0,
      cancelled: 0,
      failed: 0,
      inComplete: 0,
      pending: 0,
      review_window: 0,
      count: 0,
    },
    {
      messageType: "OrderShipConfFromFD",
      processing: 0,
      shipped: 0,
      completed: 0,
      accepted: 0,
      cancelled: 0,
      failed: 0,
      inComplete: 0,
      pending: 0,
      review_window: 0,
      count: 0,
    },
    {
      messageType: "ShipConfSentToAS400",
      processing: 0,
      shipped: 0,
      completed: 0,
      accepted: 0,
      cancelled: 0,
      failed: 0,
      inComplete: 0,
      pending: 0,
      review_window: 0,
      count: 0,
    },
    {
      messageType: "ShipConfACKFromAS400",
      processing: 0,
      shipped: 0,
      completed: 0,
      accepted: 0,
      cancelled: 0,
      failed: 0,
      inComplete: 0,
      pending: 0,
      review_window: 0,
      count: 0,
    },
    {
      messageType: "Others",
      processing: 0,
      shipped: 0,
      completed: 0,
      accepted: 0,
      cancelled: 0,
      failed: 0,
      inComplete: 0,
      pending: 0,
      review_window: 0,
      count: 0,
    }
  ];

  messageTypeforOrdersCount = [
    "Ord_SentTo_AS400",
    "AS400_Failure",
    "Ord_ACK_From_AS400",
    "Ord_SentTo_FD",
    "FD_Failure",
    "Ord_ACK_From_FD",
    "SysOrd_ID_SentTo_AS400",
    "SysOrd_ReceivedFrom_AS400",
    "Fulfillment_ID_From_FD",
    "Ord_ShipConf_From_FD",
    "ShipConf_SentTo_AS400",
    "ShipConf_ACK_From_AS400",
    "Others"
  ];


  constructor(
    private _translateService: TranslateService,
    private _customerservice: CustomerService,
    private _reportService: ReportService,
    private _commonService: CommonService,
    private _datePipe: DatePipe,
    private distributorFormatPipe: DistributorIdFormatPipe,
    private _currencyPipe: CurrencyTransformPipe,
    private _payvisionService: PayvisionService,    
    private _cacheService: CacheService
  ) {}

  ngOnInit(): void {
    this.orderLogResponse=[];
    // this.getOrdersCountReport();
    // this.getOrdersDashboardReport();
    this.exportFile('csv');
  }

  // this.getOrderCountReport(this._reportService.getConstructedUrl(this.storeId,this.fromDate,this.toDate));
    
  getOrdersDashboardReport(): void {
    this.isLoading = true;

    this.getOrderDashBoardsReport(this._reportService.getConstructedOrderDashBoardUrl(
      this.storeId,this.fromDate,this.toDate,this.pageNumber,this.pageSize,false));
  
  }

  /**
   * To get orders dashboard report
   * @returns void
   */
  // getOrdersDashboardsReport(): void {
  //   this.isLoading = true;
  //   this._reportService
  //     .getOrdersDashboardReport(
  //       this.storeId,
  //       this.fromDate,
  //       this.toDate,
  //       this.pageNumber,
  //       this.pageSize,
  //       false
  //     )
  //     .subscribe(
  //       (response) => {
  //         if (response && response.content) {
  //           this.dashboardReports = response.content;

  //           // logic for removeing quotes
  //           this.dashboardReports.forEach(eachDashboardReport=>{
  //             eachDashboardReport.fboId =   eachDashboardReport.fboId.replaceAll("'",''); 
  //           })


  //           this.isLoading = false;
  //           this.isResponseError = false;
  //           this.pageCount = response.totalCount;
  //           this.isLoadedData.emit(true);
  //         } else if (
  //           response &&
  //           response.status &&
  //           response.status.code === 504
  //         ) {
  //           const message: any = this._translateService.get(
  //             "reports.Sorry It seems like you selected wider date range Please select the minimum date range and try again"
  //           );
  //           this._commonService.createNotification(
  //             "",
  //             message.value,
  //             NotificationType.ERROR
  //           );
  //           this.setDefaultValues();
  //         } else {
  //           this.setDefaultValues();
  //         }
  //       },
  //       (error) => {
  //         if (
  //           error.status == 504 ||
  //           (error.name && error.name.toLowerCase() == "typeerror")
  //         ) {
  //           const message: any = this._translateService.get(
  //             "reports.Sorry It seems like you selected wider date range Please select the minimum date range and try again"
  //           );
  //           this._commonService.createNotification(
  //             "",
  //             message.value,
  //             NotificationType.ERROR
  //           );
  //           this.setDefaultValues();
  //         } else {
  //           const message: any = this._translateService.get(
  //             "reports.Something Went Wrong, Please try again after some time"
  //           );
  //           this._commonService.createNotification(
  //             "",
  //             message.value,
  //             NotificationType.ERROR
  //           );
  //           this.setDefaultValues();
  //         }
  //       }
  //     );
  // }

  getOrderDashBoardsReport(url: string) {
    this.request = this._reportService
      .getOrderDashBoardPollReport(url)
      .subscribe(res => {
        if (res.status === ResponseStatus.COMPLETED) {
          this.reportOrderDashBoardSuccess(res.responseModel);
        } else {
          this.reportOrderDashBoardPending(res);
        }
      },
        (error) => {
              if (
                error.status == 504 ||
                (error.name && error.name.toLowerCase() == "typeerror")
              ) {
                const message: any = this._translateService.get(
                  "reports.Sorry It seems like you selected wider date range Please select the minimum date range and try again"
                );
                this._commonService.createNotification(
                  "",
                  message.value,
                  NotificationType.ERROR
                );
                this.setDefaultValues();
              } else {
                const message: any = this._translateService.get(
                  "reports.Something Went Wrong, Please try again after some time"
                );
                this._commonService.createNotification(
                  "",
                  message.value,
                  NotificationType.ERROR
                );
                this.setDefaultValues();
              }
            });
  }

  reportOrderDashBoardSuccess(response: any) {
    if (response && response.content) {
      this.dashboardReports = response.content;

      // logic for removeing quotes
      this.dashboardReports.forEach(eachDashboardReport=>{
        eachDashboardReport.fboId =   eachDashboardReport.fboId.replaceAll("'",''); 
      })

      this.pollCount = 0;
      this.isLoading = false;
      this.isResponseError = false;
      this.pageCount = response.totalCount;
      this.isLoadedData.emit(true);
      this.exportFile('csv');
    } else if (
      response &&
      response.status &&
      response.status.code === 504
    ) {
      const message: any = this._translateService.get(
        "reports.Sorry It seems like you selected wider date range Please select the minimum date range and try again"
      );
      this._commonService.createNotification(
        "",
        message.value,
        NotificationType.ERROR
      );
      this.setDefaultValues();
    } else {
      this.setDefaultValues();
    }
    
  }

  reportOrderDashBoardPending(res: any) {
    if ((res.status === ResponseStatus.IN_PROGRESS) || (res.status === ResponseStatus.QUEUED)) {
      // if (this.pollCount < environment.longPollCount) {
      //   if (this._cacheService.get(CacheKey.pollCount)) {
      //     this.pollCount = parseInt(this._cacheService.get(CacheKey.pollCount));
      //   } else {
      //     this._cacheService.set(CacheKey.pollCount, "1");
      //   }
      //   this.pollCount = this.pollCount + 1;
      //   this._cacheService.set(CacheKey.pollCount, this.pollCount + "");
        if (this.pollCount < this.maxPollCount) {
          this.pollCount = this.pollCount + 1;
          this.getOrderDashBoardsReport(res.location);
      }
      else{
        const message: any = this._translateService.get("reports.Something Went Wrong, Please try again after some time");
        this._commonService.createNotification("",message.value,NotificationType.ERROR);
      }
        // this.getOrderCountReport(res.location);
      
    } else {
      this._cacheService.remove(CacheKey.pollCount);
    }
    this._cacheService.remove(CacheKey.pollCount);
  }

  /**
   * To get orders report
   * @returns void
   */
  getOrdersCountReport(): void {
    this.isLoading = true;

    this.getOrderCountReport(this._reportService.getConstructedUrl(this.storeId,this.fromDate,this.toDate));
    // this._reportService
    //   .getOrdersCountReport(
    //     this.storeId,
    //     this.fromDate,
    //     this.toDate
    //     // this.pageNumber,
    //     // this.pageSize,
    //     // false
    //   )
      // .subscribe(
      //   (response) => {
      //     if (response && response.content) {
      //       this.ordersCount = response.content;
      //       this.isLoading = false;
      //       this.isResponseError = false;
      //       this.pageCount = response.totalCount;
      //       this.isLoadedData.emit(true);

      //       // for static display
      //       if(this.ordersCount.length) {
      //         this.ordersCount.forEach((orderCount) => {
      //           this.displayDashboard.forEach((display) => {
      //             if (display.messageType === orderCount.messageType) {
      //               display.processing = orderCount.processing;
      //               display.shipped = orderCount.shipped;
      //               display.completed = orderCount.completed;
      //               display.accepted = orderCount.accepted;
      //               display.cancelled =orderCount.cancelled; 
      //               display.failed = orderCount.failed;
      //               display.inComplete = orderCount.inComplete;
      //               display.pending = orderCount.pending;
      //               display.review_window = orderCount.review_window;
      //               display.count = orderCount.count;
      //             }
      //           });
      //         });
      //       }

      //       // message naming as per TRB-3491
      // for (let i = 0; i < this.displayDashboard.length; i++) {
      //   this.displayDashboard[i].messageType =
      //     this.messageTypeforOrdersCount[i];
      // }
            
      //     } else if (
      //       response &&
      //       response.status &&
      //       response.status.code === 504
      //     ) {
      //       const message: any = this._translateService.get(
      //         "reports.Sorry It seems like you selected wider date range Please select the minimum date range and try again"
      //       );
      //       this._commonService.createNotification(
      //         "",
      //         message.value,
      //         NotificationType.ERROR
      //       );
      //       this.setDefaultValues();
      //     } else {
      //       this.setDefaultValues();
      //     }
      //   },
      //   (error) => {
      //     if (
      //       error.status == 504 ||
      //       (error.name && error.name.toLowerCase() == "typeerror")
      //     ) {
      //       const message: any = this._translateService.get(
      //         "reports.Sorry It seems like you selected wider date range Please select the minimum date range and try again"
      //       );
      //       this._commonService.createNotification(
      //         "",
      //         message.value,
      //         NotificationType.ERROR
      //       );
      //       this.setDefaultValues();
      //     } else {
      //       const message: any = this._translateService.get(
      //         "reports.Something Went Wrong, Please try again after some time"
      //       );
      //       this._commonService.createNotification(
      //         "",
      //         message.value,
      //         NotificationType.ERROR
      //       );
      //       this.setDefaultValues();
      //     }
      //   }
      // );
      
  }

  getOrderCountReport(url: string) {
    this.request = this._reportService
      .getOrdersCountsPollReport(url)
      .subscribe(res => {
        if (res.status === ResponseStatus.COMPLETED) {
          this.reportSuccess(res.responseModel);
        } else {
          this.reportPending(res);
        }
      },
        (error) => {
              if (
                error.status == 504 ||
                (error.name && error.name.toLowerCase() == "typeerror")
              ) {
                const message: any = this._translateService.get(
                  "reports.Sorry It seems like you selected wider date range Please select the minimum date range and try again"
                );
                this._commonService.createNotification(
                  "",
                  message.value,
                  NotificationType.ERROR
                );
                this.setDefaultValues();
              } else {
                const message: any = this._translateService.get(
                  "reports.Something Went Wrong, Please try again after some time"
                );
                this._commonService.createNotification(
                  "",
                  message.value,
                  NotificationType.ERROR
                );
                this.setDefaultValues();
              }
            });
  }

  reportSuccess(response: any) {
      if (response && response.content) {
        this.ordersCount = response.content;
        this.isLoading = false;
        this.isResponseError = false;
        this.isLoadedData.emit(true);
        this.pollCount = 0;
        // for static display
        if(this.ordersCount.length) {
          this.ordersCount.forEach((orderCount) => {
            this.displayDashboard.forEach((display) => {
              if (display.messageType === orderCount.messageType) {
                display.processing = orderCount.processing;
                display.shipped = orderCount.shipped;
                display.completed = orderCount.completed;
                display.accepted = orderCount.accepted;
                display.cancelled =orderCount.cancelled; 
                display.failed = orderCount.failed;
                display.inComplete = orderCount.inComplete;
                display.pending = orderCount.pending;
                display.review_window = orderCount.review_window;
                display.count = orderCount.count;
              }
            });
          });
        }

        // message naming as per TRB-3491
  for (let i = 0; i < this.displayDashboard.length; i++) {
    this.displayDashboard[i].messageType =
      this.messageTypeforOrdersCount[i];
  }
        
      } else if (
        response &&
        response.status &&
        response.status.code === 504
      ) {
        const message: any = this._translateService.get(
          "reports.Sorry It seems like you selected wider date range Please select the minimum date range and try again"
        );
        this._commonService.createNotification(
          "",
          message.value,
          NotificationType.ERROR
        );
        this.setDefaultValues();
      } else {
        this.setDefaultValues();
      }
    
  }

  reportPending(res: any) {
    if ((res.status === ResponseStatus.IN_PROGRESS) || (res.status === ResponseStatus.QUEUED)) {
      // if (this.pollCount < environment.longPollCount) {
      //   if (this._cacheService.get(CacheKey.pollCount)) {
      //     this.pollCount = parseInt(this._cacheService.get(CacheKey.pollCount));
      //   } else {
      //     this._cacheService.set(CacheKey.pollCount, "1");
      //   }
      //   this.pollCount = this.pollCount + 1;
      //   this._cacheService.set(CacheKey.pollCount, this.pollCount + "");
      //   this.getOrderCountReport(res.location);
      // }
      if (this.pollCount < this.maxPollCount) {
        this.pollCount = this.pollCount + 1;
        this.getOrderCountReport(res.location);
    }
    } else {
      this._cacheService.remove(CacheKey.pollCount);
    }
    this._cacheService.remove(CacheKey.pollCount);
  }

 



  
  onClickPaymentStatus(webOrderId:string){
    this.orderLogResponse=[];
    this._payvisionService.getPaymentLogs(webOrderId).subscribe(response=>{
      if(response && response.length>0){
        this.isPaymentLog=true;
        response.forEach((element) => {
          if (element.requestTimestamp) {
            element.requestTimestamp = this.getUtcDate(element.requestTimestamp);
          }
          if (element.responseTimestamp) {
            element.responseTimestamp = this.getUtcDate(element.responseTimestamp);
          }
        });
        this.orderLogResponse=response;
      } else {
        const message: any = this._translateService.get(
          "reports.Logs are Not available"
        );
        this._commonService.createNotification(
          "",
          message.value,
          NotificationType.ERROR
        );
      }

    });

  }
  onClickDistributor(report:any){
    this.orderLogResponse=[];
    this.OrderLog=[];
    let requesrList=[];
    this.isPaymentLog=false;
    let request1:any=this.createLogRequest(report.fboId);
    requesrList.push(request1); 
    let request2:any=this.createLogRequest(report.webOrdID);
    requesrList.push(request2);
    if(report.orderConfirmationEmail){
    let request3:any=this.createLogRequest(report.orderConfirmationEmail);
    requesrList.push(request3);
    }
    this._reportService.requestDataFromMultipleLogsFromValenceAndCommuniCation(requesrList).subscribe(responseList => {
      let orderlog =[];
       if(responseList && responseList.length>0){
         responseList.forEach(item=>{
           if(item && item.requestLookUpDetails && item.requestLookUpDetails.length>0){
             item.requestLookUpDetails.forEach(element => {
               if (element.requestTimestamp) {
                 element.requestTimestamp = this.getUtcDate(element.requestTimestamp);
               }
               if (element.responseTimestamp) {
                 element.responseTimestamp = this.getUtcDate(element.responseTimestamp);
               }
               orderlog.push(element);
             });
         
           }
         });
       }
       this.orderLogResponse=orderlog;
       
     });

  }

  getUtcDate(timeStamp: any): string {
    if (typeof (timeStamp) == 'number') {
      timeStamp = moment.utc(timeStamp).toISOString();
    }
    if (typeof (timeStamp) == 'string') {
      if (timeStamp && timeStamp.indexOf('T') > -1 && timeStamp.indexOf('.') > -1) {
        timeStamp = timeStamp.split('.')[0];
      }
    }
    return timeStamp;
  }


  onClickWebOrderNumber(refID:string){
  this.orderLogResponse=[];
  this.OrderLog=[];
  let request:any=this.createLogRequest(refID);
  this.isPaymentLog=false;
  this._reportService.requestDataFromMultipleLogs(request).subscribe(responseList => {
   let orderlog =[];
    if(responseList && responseList.length>0){
      responseList.forEach(item=>{
        if(item && item.requestLookUpDetails && item.requestLookUpDetails.length>0){
          item.requestLookUpDetails.forEach(element => {
            if (element.requestTimestamp) {
              element.requestTimestamp = this.getUtcDate(element.requestTimestamp);
            }
            if (element.responseTimestamp) {
              element.responseTimestamp = this.getUtcDate(element.responseTimestamp);
            }
            orderlog.push(element);
          });
      
        }
      });
    }
    this.orderLogResponse=orderlog;
   if(this.orderLogResponse && this.orderLogResponse.length==0){
      const message: any = this._translateService.get(
        "reports.Logs are Not available"
      );
      this._commonService.createNotification(
        "",
        message.value,
        NotificationType.ERROR
      );
    }
    
  });
 }

 createLogRequest(refid:any):any{
  let startDate = new Date(this.fromDate);
  let endDate = new Date(this.toDate);
  startDate = new Date(startDate.getTime() - (startDate.getTimezoneOffset()*60*1000));
  endDate = new Date(endDate.getTime() - (endDate.getTimezoneOffset()*60*1000));
  endDate.setHours(23);
  endDate.setMinutes(59);
  endDate.setSeconds(59);
  const request={
      "messageType": 0,
      "refId": refid,
      "startDate": startDate,
      "endDate": endDate,
      "pageNumber": 1,
      "pageSize": 10,
      "export": false
    }
return request;
 }

  /**
   * To Set Default Values
   */
  setDefaultValues(): void {
    this.isLoading = false;
    this.isResponseError = true;
    this.pageCount = 0;
    this.isLoadedData.emit(true);
  }

  /**
   * To load orders report
   * @returns void
   */
  loadOrdersReports(): void {
    this.isShowReport = true;
    this.getOrdersCountReport();
    this.getOrdersDashboardReport();
  }

  /**
   * To emit add favorite event to parent component
   * @returns void
   */
  addToFavorite(): void {
    this.addFavoriteEvent.emit(true);
  }

  /**
   * To Export The file
   */
  exportFile(type): void {
    this.fetchAllOrdersReport(type);
    // if (this.allOrdersReport && this.allOrdersReport.length > 0) {
    //   this.download(type);
    // } else {
    //   this.fetchAllOrdersReport(type);
    // }
  }

  /**
   * To Fetch all orders report data from service
   */
  fetchAllOrdersReport(type): void {
    this.isAllOrdersReportLoading = true;
    this.isLoading = true;
    this.getOrdersDashboardReportToExportFile(this._reportService.getConstructedOrderDashBoardUrl(
        this.storeId,this.fromDate,this.toDate,this.pageNumber,this.pageSize,true),type);
  }

  getOrdersDashboardReportToExportFile(url: string,type){
    this.request = this._reportService
    .getOrderDashBoardPollReport(url)
    .subscribe(res => {
      if (res.status === ResponseStatus.COMPLETED) {
        this.isAllOrdersReportLoading = false;
        this.isLoading = false;
        this.pollCount = 0;
        this.allOrdersReport = res.responseModel ? res.responseModel.content : null;
        this.dashboardReports = res.content;
        this.download(type);
        this.isLoadedData.emit(true);
      } else {
        if ((res.status === ResponseStatus.IN_PROGRESS) || (res.status === ResponseStatus.QUEUED)) {
          if (this.pollCount < this.maxPollCount) {
            this.pollCount = this.pollCount + 1;
            this.getOrdersDashboardReportToExportFile(res.location,type);
          }
          else{
            this.isAllOrdersReportLoading = false;
            this.allOrdersReport = null;
            const message: any = this._translateService.get("reports.Something Went Wrong, Please try again after some time");
            this._commonService.createNotification("",message.value,NotificationType.ERROR);
            this.setDefaultValues();
          }      
        } 
      }
    },
      (error) => {
        const message: any = this._translateService.get("reports.Something Went Wrong, Please try again after some time");
              this._commonService.createNotification("",message.value,NotificationType.ERROR);
              this.allOrdersReport = null;
              this.isAllOrdersReportLoading = false;
              this.setDefaultValues();
            });
  }

  /**
   * To download CSV or Print file from response data
   * @param  {string} type
   * @returns void
   */
  download(type: string): void {
    const allOrdersReportLength =
      this.allOrdersReport && this.allOrdersReport.length
        ? this.allOrdersReport && this.allOrdersReport.length
        : null;
    if (allOrdersReportLength > 0) {
      const columns = [
        this._translateService.get("raw-data.FBO_ID")["value"],
        this._translateService.get("raw-data.Email_Id")["value"],
        this._translateService.get("raw-data.Member_Type")["value"],
        this._translateService.get("raw-data.WebOrd_ID")["value"],
        this._translateService.get("raw-data.SysOrd_ID")["value"],
        this._translateService.get("raw-data.Order_Created_Date")["value"],
        this._translateService.get("raw-data.Fulfillment_ID")["value"],
        this._translateService.get("raw-data.FD_Failure")["value"],
        this._translateService.get("raw-data.Ord_Status")["value"],
        this._translateService.get("raw-data.Payment_Type")["value"],
        this._translateService.get("raw-data.Payment_Status")["value"],
        this._translateService.get("raw-data.Ord_Type")["value"],
        this._translateService.get("raw-data.Ord_Source")["value"],
        this._translateService.get("raw-data.Ord_Total")["value"],
        this._translateService.get("raw-data.CCTotal")["value"],
        this._translateService.get("raw-data.Ord_SentTo_AS400")["value"],
        this._translateService.get("raw-data.AS400_Failure")["value"],
        this._translateService.get("raw-data.Ord_ACK_From_AS400")["value"],
        this._translateService.get("raw-data.Ord_SentTo_FD")["value"],

        this._translateService.get("raw-data.Ord_ACK_From_FD")["value"],
        
        this._translateService.get("raw-data.SysOrd_ID_SentTo_AS400")["value"],
        this._translateService.get("raw-data.SysOrd_ID_FailureReason")["value"],
        this._translateService.get("raw-data.SysOrd_ReceivedFrom_AS400")[
          "value"
        ],
        this._translateService.get("raw-data.ProcessingPeriod")["value"],
        this._translateService.get("raw-data.Fulfillment_ID_From_FD")["value"],
        this._translateService.get("raw-data.Ord_ShipConf_From_FD")["value"],
        this._translateService.get("raw-data.ShipConf_SentTo_AS400")["value"],
        this._translateService.get("raw-data.ShipConf_ACK_From_AS400")["value"],
        this._translateService.get("raw-data.Ord_Conf_Email")["value"],
        this._translateService.get("raw-data.Ship_Conf_Email")["value"],
        this._translateService.get("raw-data.PaybyLink_Email")["value"],
        this._translateService.get("raw-data.Report_DateTime")["value"],
        this._translateService.get("raw-data.ERPNumber_Received")["value"],
        this._translateService.get("raw-data.ERP_Failure")["value"],
        this._translateService.get("raw-data.Order_Submitted_ToERP")["value"],
        this._translateService.get("raw-data.Order_Shipped_From")["value"],
        
      ];
      const title =
        this._translateService.get("reports.Orders Report")["value"] +
        "_" +
        this.fromDate +
        this._translateService.get("reports._To_")["value"] +
        this.toDate;
      if (type === this.csvType) {
        this.downloadCSV(columns, allOrdersReportLength);
      } else if (type === this.printType) {
        this.printReportDetails(title, columns, allOrdersReportLength);
      }
    }
  }

  /**
   * CSV file download functionality
   */
  downloadCSV(columns: any, allOrdersReportLength: any) {
    let rowdata = new Array<any>();
    const finalrows = new Array<any>();
    for (let i = 0; i < allOrdersReportLength; i++) {
      rowdata = [];
      const row = this.allOrdersReport[i];
       rowdata.push(row.fboId ? row.fboId : "");
      rowdata.push(row.emailId ? row.emailId : "");
      rowdata.push(row.memberType ? row.memberType :"");
      rowdata.push(row.webOrdID ? row.webOrdID : "");
      rowdata.push(row.sysOrdID ? row.sysOrdID : "");
      rowdata.push(row.orderCreatedDate ? row.orderCreatedDate : "");
      rowdata.push(row.fulfillmentID ? row.fulfillmentID : "");
      rowdata.push(row.fDFailure ? row.fDFailure : "");
      rowdata.push(row.ordStatus ? row.ordStatus : "");
      rowdata.push(row.paymentType ? row.paymentType :"");
      rowdata.push(row.paymentStatus ? row.paymentStatus : "");
      rowdata.push(row.ordType ? row.ordType : "");
      rowdata.push(row.ordSource ? row.ordSource : "");
      rowdata.push(row.ordTotal ? row.ordTotal : "");
      rowdata.push(row.totalCC ? row.totalCC : "");
      rowdata.push(row.ordSentToAS400 ? row.ordSentToAS400 : "");
      rowdata.push(row.aS400Failure ? row.aS400Failure : "");
      rowdata.push(row.ordACKFromAS400 ? row.ordACKFromAS400 : "");
      rowdata.push(row.ordSentToFD ? row.ordSentToFD : "");

      rowdata.push(row.ordACKFromFD ? row.ordACKFromFD : "");
      const distributorId = row.distributorId ? row.distributorId : "";
      // rowdata.push(distributorId);
      rowdata.push(row.sysOrdIDSentToAS400 ? row.sysOrdIDSentToAS400 : "");
      rowdata.push(
        row.sysytemOrderNumberFailureReason
          ? row.sysytemOrderNumberFailureReason
          : ""
      );
      rowdata.push(
        row.sysOrdReceivedFromAS400 ? row.sysOrdReceivedFromAS400 : ""
      );
      rowdata.push(
        row.processingPeriod ? row.processingPeriod : ""
      );
      rowdata.push(row.fulfillmentIDFromFD ? row.fulfillmentIDFromFD : "");
      rowdata.push(row.ordShipConfFromFD ? row.ordShipConfFromFD : "");
      rowdata.push(row.shipConfSentToAS400 ? row.shipConfSentToAS400 : "");
      rowdata.push(row.shipConfACKFromAS400 ? row.shipConfACKFromAS400 : "");
      rowdata.push(
        row.orderConfirmationEmail ? row.orderConfirmationEmail : ""
      );
      rowdata.push(row.shipconfirmationEmail ? row.shipconfirmationEmail : "");
      rowdata.push(row.payByLinKEmail ? row.payByLinKEmail : "");
      rowdata.push(row.reportDateTime ? row.reportDateTime :"");
      rowdata.push(row.eRPNumberReceived ? row.eRPNumberReceived : "");
      rowdata.push(row.erpFailure ? row.erpFailure : "");
      rowdata.push(row.orderSubmittedToERP ? row.orderSubmittedToERP : "");
      rowdata.push(row.distributionCenter ? row.distributionCenter : "");

      finalrows.push(rowdata);
    }
    this._customerservice.ExcelDownload(
      columns,
      finalrows,
      "Orders Raw-Data",
      "",
      false
    );
  }

  /**
   * Print functionality for report details printing
   */
  printReportDetails(title: string, columns: any, allOrdersReportLength: any) {
    let rowdataForPrint = new Array<any>();
    const finalrowsForPrint = new Array<any>();
    for (let i = 0; i < allOrdersReportLength; i++) {
      rowdataForPrint = [];
      const rowForPrint = this.allOrdersReport[i];

      rowdataForPrint.push(rowForPrint.fboId ? rowForPrint.fboId : "");
      rowdataForPrint.push(rowForPrint.emailId ? rowForPrint.emailId : "");
      rowdataForPrint.push(rowForPrint.memberType ? rowForPrint.memberType :"");
      rowdataForPrint.push(rowForPrint.webOrdID ? rowForPrint.webOrdID : "");
      rowdataForPrint.push(rowForPrint.sysOrdID ? rowForPrint.sysOrdID : "");
      rowdataForPrint.push(rowForPrint.orderCreatedDate ? rowForPrint.orderCreatedDate : "");
      rowdataForPrint.push(
        rowForPrint.fulfillmentID ? rowForPrint.fulfillmentID : ""
      );
      rowdataForPrint.push(rowForPrint.fDFailure ? rowForPrint.fDFailure : "");
      rowdataForPrint.push(rowForPrint.ordStatus ? rowForPrint.ordStatus : "");
      rowdataForPrint.push(rowForPrint.paymentType ? rowForPrint.paymentType :"");
      rowdataForPrint.push(
        rowForPrint.paymentStatus ? rowForPrint.paymentStatus : ""
      );
      rowdataForPrint.push(rowForPrint.ordType ? rowForPrint.ordType : "");
      rowdataForPrint.push(rowForPrint.ordSource ? rowForPrint.ordSource :"");
      rowdataForPrint.push(rowForPrint.ordTotal ? rowForPrint.ordTotal :"");
      rowdataForPrint.push(rowForPrint.totalCC ? rowForPrint.totalCC :"");
      rowdataForPrint.push(
        rowForPrint.ordSentToAS400 ? rowForPrint.ordSentToAS400 : ""
      );
      rowdataForPrint.push(
        rowForPrint.aS400Failure ? rowForPrint.aS400Failure : ""
      );
      rowdataForPrint.push(
        rowForPrint.ordACKFromAS400 ? rowForPrint.ordACKFromAS400 : ""
      );
      rowdataForPrint.push(
        rowForPrint.ordSentToFD ? rowForPrint.ordSentToFD : ""
      );

      rowdataForPrint.push(
        rowForPrint.ordACKFromFD ? rowForPrint.ordACKFromFD : ""
      );
      rowdataForPrint.push(
        rowForPrint.sysOrdIDSentToAS400 ? rowForPrint.sysOrdIDSentToAS400 : ""
      );
      rowdataForPrint.push(
        rowForPrint.sysytemOrderNumberFailureReason
          ? rowForPrint.sysytemOrderNumberFailureReason
          : ""
      );
      rowdataForPrint.push(
        rowForPrint.sysOrdReceivedFromAS400
          ? rowForPrint.sysOrdReceivedFromAS400
          : ""
      );
      rowdataForPrint.push(
        rowForPrint.fulfillmentIDFromFD ? rowForPrint.fulfillmentIDFromFD : ""
      );
      rowdataForPrint.push(
        rowForPrint.ordShipConfFromFD ? rowForPrint.ordShipConfFromFD : ""
      );
      rowdataForPrint.push(
        rowForPrint.shipConfSentToAS400 ? rowForPrint.shipConfSentToAS400 : ""
      );
      rowdataForPrint.push(
        rowForPrint.shipConfACKFromAS400 ? rowForPrint.shipConfACKFromAS400 : ""
      );
      rowdataForPrint.push(
        rowForPrint.orderConfirmationEmail
          ? rowForPrint.orderConfirmationEmail
          : ""
      );
      rowdataForPrint.push(
        rowForPrint.shipconfirmationEmail
          ? rowForPrint.shipconfirmationEmail
          : ""
      );
      rowdataForPrint.push(
        rowForPrint.payByLinKEmail ? rowForPrint.payByLinKEmail : ""
      );
      rowdataForPrint.push(rowForPrint.reportDateTime ? rowForPrint.reportDateTime :"");
      rowdataForPrint.push(
        rowForPrint.eRPNumberReceived ? rowForPrint.eRPNumberReceived : ""
      );
      rowdataForPrint.push(
        rowForPrint.erpFailure ? rowForPrint.erpFailure : ""
      );
      rowdataForPrint.push(
        rowForPrint.orderSubmittedToERP ? rowForPrint.orderSubmittedToERP : ""
      );
      rowdataForPrint.push(rowForPrint.distributionCenter ? rowForPrint.distributionCenter : "");

     
      finalrowsForPrint.push(rowdataForPrint);
    }
    this._customerservice.constructTableAndPrint(
      columns,
      finalrowsForPrint,
      title
    );
  } 

   /**
    * To change page size
    * @param  {number} pageSize
    * @returns void
    */
    pageSizeChange(pageSize: number): void {
      if (pageSize) {
          this.pageNumber = 1;
          this.pageSize = pageSize;
          this.getOrdersDashboardReport();
      }
  }

  /**
   * To change page number
   * @param  {number} pageNumber
   */
  pageChange(pageNumber: number) {
      this.pageNumber = pageNumber;
      this.pollCount = 0;
      this.getOrdersDashboardReport();
  }
 
}



// WEBPACK FOOTER //
// ./src/app/customerservice/components/reports/order-dashboard.component.ts